import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-railtrac-reports',
  template: `
    <p>
      railtrac-reports works!
    </p>
  `,
  styles: [
  ]
})
export class RailtracReportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
